import { render, staticRenderFns } from "./DoctorPageLpuListPhone.vue?vue&type=template&id=74812044&"
import script from "./DoctorPageLpuListPhone.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DoctorPageLpuListPhone.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74812044')) {
      api.createRecord('74812044', component.options)
    } else {
      api.reload('74812044', component.options)
    }
    module.hot.accept("./DoctorPageLpuListPhone.vue?vue&type=template&id=74812044&", function () {
      api.rerender('74812044', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorPageLpuList/components/DoctorPageLpuListPhone.vue"
export default component.exports